export default {
  dealer: null,
  dealers: [],
};
